import {
  state as reactiveState,
  useFragment,
  useReactiveState,
} from '@frameio/graphql-client';
import { PaymentMethodSubscription } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function useGetBillingCountry() {
  const accountId = useActiveAccountId() ?? '';

  const cachedStripeData = useReactiveState(reactiveState.billing.stripe);

  const cachedStripeBillingCountry =
    cachedStripeData?.addressElementValue?.address?.country;

  const { data } = useFragment({
    fragment: PaymentMethodSubscription,
    fragmentName: 'PaymentMethodSubscription',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  const billingCountry =
    data?.subscription?.paymentMethod?.__typename === 'PaymentCard'
      ? data?.subscription?.paymentMethod?.billingAddress?.country
      : undefined;

  return cachedStripeBillingCountry || billingCountry;
}
